import { __extends } from "tslib";
import * as React from 'react';
var fontSize = 12;
var idCnt = 0;
var Gist = (function (_super) {
    __extends(Gist, _super);
    function Gist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iframeNode = null;
        _this.id = 'react-embed-gist-' + idCnt++;
        return _this;
    }
    Gist.prototype.componentDidMount = function () {
        this._updateIframeContent();
    };
    Gist.prototype.componentDidUpdate = function (prevProps, prevState) {
        this._updateIframeContent();
    };
    Gist.prototype._defineUrl = function () {
        var _a = this.props, id = _a.id, file = _a.file;
        var fileArg = file ? "?file=".concat(file) : '';
        return "https://gist.github.com/".concat(id, ".js").concat(fileArg);
    };
    Gist.prototype._updateIframeContent = function () {
        var iframe = this.iframeNode;
        var doc = iframe.document;
        if (iframe.contentDocument)
            doc = iframe.contentDocument;
        else if (iframe.contentWindow)
            doc = iframe.contentWindow.document;
        var gistLink = this._defineUrl();
        var gistScript = "<script type=\"text/javascript\" src=\"".concat(gistLink, "\"></script>");
        var styles = "<style>*{font-size:".concat(fontSize, "px;}</style>");
        var resizeScript = "onload=\"parent.document.getElementById('".concat(this.id, "').style.height=document.body.scrollHeight + 'px'\"");
        var iframeHtml = "<html><head><base target=\"_parent\">".concat(styles, "</head><body style=\"margin:0\" ").concat(resizeScript, ">").concat(gistScript, "</body></html>");
        doc.open();
        doc.writeln(iframeHtml);
        doc.close();
    };
    Gist.prototype.render = function () {
        var _this = this;
        var renderWrap = this.props.renderWrap;
        return renderWrap(React.createElement("iframe", { id: this.id, ref: function (n) {
                _this.iframeNode = n;
            }, width: "100%", frameBorder: 0, style: { margin: "0 0 -".concat(fontSize, "px") } }));
    };
    return Gist;
}(React.PureComponent));
export default Gist;
//# sourceMappingURL=index.js.map